import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ContentHeadingData } from 'common/models/content-heading';
import { LanguageTranslationService } from 'common/services/language-translation.service';
import { ToastService } from 'common/services/toast.service';
import { WINDOW } from 'common/window.provider';
import { DECODE_39L_PDF_URL, PART_NUMBER_MAX_LENGTH, SapDecoderPdfType, SapModelNumberDecoderService } from 'private/app/services/sap-model-number-decoder.service';

@Component({
    selector: 'hvac-sap-model-number-decoder',
    templateUrl: './sap-model-number-decoder.component.html',
    styleUrls: ['./sap-model-number-decoder.component.scss']
})
export class SapModelNumberDecoderComponent implements OnInit {
    public breadCrumbData: ContentHeadingData;
    public readonly PART_NUMBER_MAX_LENGTH = PART_NUMBER_MAX_LENGTH;

    public readonly partNumberControl = new FormControl('', [
        Validators.required,
        Validators.maxLength(PART_NUMBER_MAX_LENGTH)
    ]);

    public readonly decode39lPdfUrl = DECODE_39L_PDF_URL;
    public show39lHelpLink = false;

    constructor(
        public sapModelNumberDecoderService: SapModelNumberDecoderService,
        public translate: TranslateService,
        private languageTranslationService: LanguageTranslationService,
        private toastService: ToastService,
        @Inject(WINDOW) private readonly window: Window

    ) { }

    ngOnInit(): void {
        this.languageTranslationService.translationsLoaded().subscribe(() => {
            this.breadCrumbData = this.sapModelNumberDecoderService.breadCrumbData;
            this.sapModelNumberDecoderService.setAdminBreadCrumbData(this.breadCrumbData);
        });
    }

    public showAhuDetail(): void {
        this.openPdf('USS');
    }

    public showAhuPartsDetail(): void {
        const partNumber = (this.partNumberControl.value || '').trim();

        if (partNumber.toLowerCase().slice(0, 3) !== '39m') {
            this.toastService.add({
                content: this.translate.instant('SAP_PART_NUMBER_DECODER.ERRORS.BOM_39M_ONLY'),
                theme: 'error',
                id: 'bom_39_only',
                closeable: true,
                autoClose: true
            });

            return;
        }

        this.openPdf('BOM');
    }

    private openPdf(pdfType: SapDecoderPdfType): void {
        this.clearError();
        const partNumber = (this.partNumberControl.value || '').trim();

        if (!partNumber) {
            return;
        }

        const invalidMessageKey = this.sapModelNumberDecoderService.getInvalidMessage(partNumber);
        if (invalidMessageKey) {
            this.toastService.add({
                content: this.translate.instant(invalidMessageKey),
                theme: 'error',
                id: 'invalid_ods',
                closeable: true,
                autoClose: true
            });
            this.show39lHelpLink = invalidMessageKey === 'SAP_PART_NUMBER_DECODER.ERRORS.L39_NOT_ONLINE';

            return;
        }

        const result = this.sapModelNumberDecoderService.resolvePdfUrl(partNumber, pdfType);
        if (!result) {
            this.toastService.add({
                content: this.translate.instant('SAP_PART_NUMBER_DECODER.ERRORS.INVALID_ODS', { partNumber: partNumber }),
                theme: 'error',
                id: 'invalid_ods',
                closeable: true,
                autoClose: true
            });

            return;
        }

        this.window.open(result.url, 'AHUDetails');
    }

    private clearError(): void {
        this.show39lHelpLink = false;
    }
}
